<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h5 class="heading-1 mb-4">
                            <span>Equipe de Apoio</span>
                        </h5>
                        <app-tabela
                            :itens="apoios"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <btn-incluir-apoio
                                    class="float-right"
                                    :apoiosServicos="apoiosServicos"
                                    @obterApoiosAtualizados="
                                        $emit('obterApoiosAtualizados')
                                    "
                                    v-if="permiteInserir"
                                ></btn-incluir-apoio>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <btn-excluir-apoio
                                    :apoio="data"
                                    :apoiosServicos="apoiosServicos"
                                    @obterApoiosAtualizados="
                                        $emit('obterApoiosAtualizados')
                                    "
                                    v-if="permiteExcluir"
                                ></btn-excluir-apoio>
                                <slot name="acoes" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import BtnIncluirApoio from './BtnIncluirApoio'
import BtnExcluirApoio from './BtnExcluirApoio'

export default {
    components: {
        BtnIncluirApoio,
        BtnExcluirApoio
    },

    props: {
        apoios: {
            type: Array,
            default: () => []
        },

        apoiosServicos: {
            type: Object,
            default: () => ({})
        },

        permiteInserir: {
            type: Boolean,
            default: () => false
        },

        permiteExcluir: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'matricula',
                    label: 'Matrícula',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'colaborador',
                    label: 'Colaborador',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {},

    computed: {},

    created() {}
}
</script>
